"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function Key(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: '0 0 64 64', width: "".concat(width) },
        react_1.default.createElement("path", { d: 'M44.9842 17.2984C40.9633 12.9005 34.4209 12.9005 30.4 17.2985C27.6533 20.3026 26.6993 24.7296 27.8886 28.746L16.2747 41.4487C16.0989 41.6411 16 41.9013 16 42.1738V47.9746C16 48.5414 16.4193 49 16.9375 49H22.2411C22.4901 49 22.7282 48.8919 22.904 48.6995L24.2296 47.2485C24.432 47.0273 24.5308 46.7169 24.4979 46.4054L24.3331 44.8473L26.307 44.644C26.7556 44.5979 27.1099 44.2104 27.152 43.7197L27.3379 41.5607L28.7624 41.7421C29.027 41.7811 29.2935 41.6839 29.494 41.4897C29.6935 41.2945 29.808 41.0161 29.808 40.7237V38.8145H31.5218C31.7709 38.8145 32.0089 38.7064 32.1847 38.514L34.5889 35.9193C38.2601 37.221 42.2378 36.2562 44.9842 33.2501C49.0053 28.8523 49.0053 21.6964 44.9842 17.2984ZM42.332 24.5493C41.2353 25.7489 39.4518 25.7489 38.355 24.5493C37.2582 23.3497 37.2582 21.399 38.355 20.1994C39.4518 18.9998 41.2353 18.9998 42.332 20.1994C43.4289 21.399 43.4288 23.3497 42.332 24.5493Z', fill: '#010101' })));
}
Key.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
Key.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = Key;
